import React from 'react'
import PropTypes from 'prop-types'
import PatientsView from './PatientsView'
import SiteCreationView from './SiteCreationView'
import AtHomeCreationView from './AtHomeCreationView'
import PasswordResetView from './PasswordResetView'
import SalesAssignment from './SalesAssignment'
import Prescribers from './PrescribersContainer'
import PatientCreationView from './PatientCreationView'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import PrescriberVerificationView from './PrescriberVerificationView'

const MAIN = 'MAIN'
const SITE_TOOLS = 'SITE_TOOLS'
const AT_HOME_TOOLS = 'AT_HOME_TOOLS'
const PASSWORD_RESET = 'PASSWORD_RESET'
const SALES_TOOLS = 'SALES_TOOLS'
const PRESCRIBER_LEADS = 'PRESCRIBER_LEADS'
const PRESCRIBER_VALIDATION = 'PRESCRIBER_VALIDATION'
const PATIENT_CREATION = 'PATIENT_CREATION'

const TABS = {
  MAIN,
  SITE_TOOLS,
  PASSWORD_RESET,
  SALES_TOOLS,
  PRESCRIBER_LEADS,
  PRESCRIBER_VALIDATION,
  PATIENT_CREATION
}

class ClinicView extends React.Component {
  static defaultProps = {
    getOrganizations: _.noop
  }

  static propTypes = {
    getOrganizations: PropTypes.func,
    organizations: PROPTYPES.organizations,
    createOrganization: PropTypes.func,
    createdOrganization: PROPTYPES.organization,
    getUsers: PropTypes.func,
    users: PROPTYPES.users,
    patients: PropTypes.object,
    createUser: PropTypes.func,
    createdUser: PROPTYPES.user,
    getSites: PropTypes.func,
    createPatient: PropTypes.func,
    getPatients: PropTypes.func,
    updatePatientBrand: PropTypes.func,
    updatePatient: PropTypes.func,
    sites: PROPTYPES.sites,
    createSite: PropTypes.func,
    updateSite: PropTypes.func,
    createdSite: PROPTYPES.site,
    getPrescriber: PropTypes.func,
    getPrescribers: PropTypes.func,
    updateSalesPerson: PropTypes.func,
    prescribers: PROPTYPES.prescribers,
    createPrescriber: PropTypes.func,
    updatePrescriberAndUploadSignature: PropTypes.func,
    createdPrescriber: PROPTYPES.prescriber,
    updatedPrescriber: PROPTYPES.prescriber,
    addPrescriberToSite: PropTypes.func,
    uploadSignature: PropTypes.func,
    uploadedSignature: PropTypes.bool,
    getDevices: PropTypes.func,
    devices: PROPTYPES.devices,
    getPharmacies: PropTypes.func,
    pharmacies: PROPTYPES.pharmacies,
    associateDeviceWithUser: PropTypes.func,
    dissociateDeviceWithUser: PropTypes.func,
    associateDeviceWithSite: PropTypes.func,
    dissociateDeviceWithSite: PropTypes.func,
    ui: PropTypes.shape({
      isFetchingOrganizations: PropTypes.bool,
      isFetchingUsers: PropTypes.bool,
      isFetchingSites: PropTypes.bool,
      isFetchingDevices: PropTypes.bool,
      isFetchingPrescribers: PropTypes.bool,
      isFetchingPharmacies: PropTypes.bool,
      isUploadingSignature: PropTypes.bool,
      isFetchingPatients: PropTypes.bool,
      isUpdatingPrescriber: PropTypes.bool,
    }),
    resetPassword: PropTypes.func,
    passwordReset: PropTypes.bool,
  }
  constructor (props) {
    super(props)
    this.state = {
      activeTab: TABS[MAIN]
    }
  }

  componentDidMount () {
    this.props.getOrganizations()
    this.props.getUsers()
    this.props.getSites()
    this.props.getDevices()
    this.props.getPrescribers()
    this.props.getPharmacies()

    if (this.props.location.hash){
      this.setState({ activeTab: this.props.location.hash.substr(1) })
    }
  }

  setActiveTab = (activeTab) => {
    this.setState({ activeTab })
  }
  render () {
    var { activeTab } = this.state

    return (
      <div>
        <div>
          <ul className='nav nav-tabs'>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[MAIN] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[MAIN])}>
                Home
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[SITE_TOOLS] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[SITE_TOOLS])}>
                Site Tools
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[AT_HOME_TOOLS] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[AT_HOME_TOOLS])}>
                At Home Tools
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[SALES_TOOLS] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[SALES_TOOLS])}>
                Sales Tools
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[PRESCRIBER_LEADS] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[PRESCRIBER_LEADS])}>
                Prescriber Leads
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[PRESCRIBER_VALIDATION] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[PRESCRIBER_VALIDATION])}>
                Prescriber Validation
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[PASSWORD_RESET] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[PASSWORD_RESET])}>
                Password Reset
              </div>
            </li>
            <li className='nav-item'>
              <div
                className={`nav-link ${activeTab === TABS[PATIENT_CREATION] ? 'active' : ''}`}
                onClick={() => this.setActiveTab(TABS[PATIENT_CREATION])}>
                Patient Tools
              </div>
            </li>
          </ul>
        </div>
        {
          activeTab === TABS[MAIN]
          ? <PatientsView
            sites={this.props.sites}
            getPatients={this.props.getPatients}
            isFetchingSites={this.props.ui.isFetchingSites}
            isFetchingPatients={this.props.ui.isFetchingPatients}
            patients={this.props.patients}
            updatePatientBrand={this.props.updatePatientBrand}
          />
          : null
        }
        {
          activeTab === TABS[SITE_TOOLS]
          ? <div style={{ textAlign: 'left' }}>
            <SiteCreationView
              isFetchingOrganizations={this.props.ui.isFetchingOrganizations}
              organizations={this.props.organizations}
              createOrganization={this.props.createOrganization}
              createdOrganization={this.props.createdOrganization}
              isFetchingUsers={this.props.ui.isFetchingUsers}
              users={this.props.users}
              createUser={this.props.createUser}
              createdUser={this.props.createdUser}
              isFetchingSites={this.props.ui.isFetchingSites}
              sites={this.props.sites}
              createSite={this.props.createSite}
              updateSite={this.props.updateSite}
              createdSite={this.props.createdSite}
              isFetchingPrescribers={this.props.ui.isFetchingPrescribers}
              prescribers={this.props.prescribers}
              createPrescriber={this.props.createPrescriber}
              createdPrescriber={this.props.createdPrescriber}
              addPrescriberToSite={this.props.addPrescriberToSite}
              updatedPrescriber={this.props.updatedPrescriber}
              uploadSignature={this.props.uploadSignature}
              uploadedSignature={this.props.uploadedSignature}
              isUploadingSignature={this.props.ui.isUploadingSignature}
              isFetchingDevices={this.props.ui.isFetchingDevices}
              devices={this.props.devices}
              associateDeviceWithSite={this.props.associateDeviceWithSite}
              dissociateDeviceWithSite={this.props.dissociateDeviceWithSite}
              isFetchingPharmacies={this.props.ui.isFetchingPharmacies}
              pharmacies={this.props.pharmacies}
            />
          </div>
          : null
        }
        {
          activeTab === TABS[AT_HOME_TOOLS]
          ? <div style={{ textAlign: 'left' }}>
            <AtHomeCreationView
              isFetchingUsers={this.props.ui.isFetchingUsers}
              users={this.props.users}
              createUser={this.props.createUser}
              createdUser={this.props.createdUser}
              isFetchingDevices={this.props.ui.isFetchingDevices}
              devices={this.props.devices}
              associateDeviceWithUser={this.props.associateDeviceWithUser}
              dissociateDeviceWithUser={this.props.dissociateDeviceWithUser}
            />
          </div>
          : null
        }
        {
          activeTab === TABS[SALES_TOOLS]
          ? <div style={{ textAlign: 'left' }}>
            <SalesAssignment
              isFetchingUsers={this.props.ui.isFetchingUsers}
              isFetchingPrescribers={this.props.ui.isFetchingPrescribers}
              prescribers={this.props.prescribers}
              users={this.props.users}
              updateSalesPerson={this.props.updateSalesPerson}
              getUsers={this.props.getUsers}
            />
          </div>
          : null
        }
        {
          activeTab === TABS[PASSWORD_RESET]
          ? <div style={{ textAlign: 'left' }}>
            <PasswordResetView
              isFetchingUsers={this.props.ui.isFetchingUsers}
              users={this.props.users}
              resetPassword={this.props.resetPassword}
              passwordReset={this.props.passwordReset}
            />
          </div>
          : null
        }
        {
          activeTab === TABS[PRESCRIBER_LEADS]
          ? <div style={{ textAlign: 'left' }}>
            <Prescribers />
          </div>
          : null
        }
        {
          activeTab === TABS[PRESCRIBER_VALIDATION]
          ? <div style={{ textAlign: 'left' }}>
            <PrescriberVerificationView
              isFetchingSites={this.props.ui.isFetchingSites}
              sites={this.props.sites}
              isFetchingPrescribers={this.props.ui.isFetchingPrescribers}
              getPrescriber={this.props.getPrescriber}
              getPrescribers={this.props.getPrescribers}
              prescribers={this.props.prescribers}
              updatePrescriber={this.props.updatePrescriberAndUploadSignature}
              updatedPrescriber={this.props.updatedPrescriber}
              isUpdatingPrescriber={this.props.ui.isUpdatingPrescriber}
              uploadSignature={this.props.uploadSignature}
              uploadedSignature={this.props.uploadedSignature}
              isUploadingSignature={this.props.ui.isUploadingSignature}
            />
          </div>
          : null
        }
        {
          activeTab === TABS[PATIENT_CREATION]
          ? <div style={{ textAlign: 'left' }}>
            <PatientCreationView
              createPatient={this.props.createPatient}
              isFetchingSites={this.props.ui.isFetchingSites}
              sites={this.props.sites}
              isFetchingPrescribers={this.props.ui.isFetchingPrescribers}
              prescribers={this.props.prescribers}
              getPatients={this.props.getPatients}
              isFetchingPatients={this.props.ui.isFetchingPatients}
              patients={this.props.patients}
              updatePatient={this.props.updatePatient}
            />
          </div>
          : null
        }
      </div>
    )
  }
}

export default ClinicView



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/ClinicView.jsx